import { ReviewEntry } from '@/domain/entities/review/reviewEntry'
import { ReviewEntryRepository } from '@/domain/repositories/review/reviewEntryRepository'

export class GetCloseReviewEntryListUseCase {
  constructor(private reviewEntryRepository: ReviewEntryRepository) {}

  async getByUserIdAndProblemIdCloseEntries(userId: string, problemId: string): Promise<ReviewEntry[]> {
    try {
      return await this.reviewEntryRepository.getByUserIdAndProblemIdCloseEntries(userId, problemId)
    } catch (error) {
      console.error(
        `Error in GetCloseReviewEntryListUseCase: ${error instanceof Error ? error.message : String(error)}`
      )
      throw error
    }
  }
}
